import { render, staticRenderFns } from "./SelectLanguageModal.vue?vue&type=template&id=5cacd206&scoped=true&"
import script from "./SelectLanguageModal.vue?vue&type=script&lang=js&"
export * from "./SelectLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguageModal.vue?vue&type=style&index=0&id=5cacd206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacd206",
  null
  
)

export default component.exports